export default __webpack_public_path__ + "static/channel-da7c46e1bb44ef31a6e6dfd9a22e4906.webp";